import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import FaSpinner from "../components/faSpinner/faSpinner";
import { FRONTEND_ORIGIN_URL_NO_SLASH } from "../config";
import Page404 from "../components/404/404";
import { newsPageRouteConverter } from "../helperFunctions/parseNews";
import withTracker from "./withtracker";
import MetaData from "../components/meta/meta";
import AuthorizationHOC from "./AuthorizationHOC";
import { ALL_USERS } from "../constants/userGroups";
import APIArticleService from "../services/BlogService";
import { parseArticleDetails } from "../constants/parse/articles";
import BlogPage from "../components/basicPage/blogPage";
import { getUserIdFromState } from "../mappers/backendMappers";
// import Breadcrumb from "../components/breadcrumb/breadcrumb";

const BlogHOC = (props) => {
  const {
    location: { pathname },
    userId,
    csrfToken,
  } = props;
  const articleId = newsPageRouteConverter(pathname, "/news/", "");

  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      setLoading(true);
      setError(null);

      try {
        const article = await APIArticleService.getArticleById(
          articleId,
          userId || "00000000-0000-0000-0000-000000000000",
          csrfToken
        );
        setPage(article);
      } catch (err) {
        console.error("Error fetching article:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    if (articleId) {
      fetchArticle();
    }
    // Once per post: the article is the same for every user, and the endpoint needs no CSRF token.
    // Re-running when userId/csrfToken arrive downloaded the article twice (8 MB posts with
    // embedded images, twice).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleId]);

  const mappedPage = parseArticleDetails(page);

  const { html, image, title, fieldScrollspyVisible, driveId } = mappedPage
    ? mappedPage
    : {};

  return (
    <div>
      <MetaData
        title={title ? title : "Page"}
        url={FRONTEND_ORIGIN_URL_NO_SLASH + pathname}
        description="Learn all the latest NBG Developer Portal news."
      />

      {!loading ? (
        html || driveId ? (
          <BlogPage
            {...mappedPage}
            pathname={pathname}
            image={image ? image : null}
            // parseArticleDetails already turns the article's hideScrollSpy into "visible";
            // inverting it again hid the section menu and Print to PDF on every post.
            fieldScrollspyVisible={fieldScrollspyVisible}
          />
        ) : (
          <Page404 />
        )
      ) : (
        <FaSpinner loading={loading} />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userId: getUserIdFromState(state),
  csrfToken: state.applicationUser?.token,
});

export default withTracker(
  AuthorizationHOC(ALL_USERS)(connect(mapStateToProps)(BlogHOC))
);
